if (!customElements.get("low-power-video")) {
  customElements.define(
    "low-power-video",
    class LowPowerVideo extends HTMLElement {
      constructor() {
        super();
        this.video_section = null;
        this.video_background_section = null;

        // store bound handlers so removeEventListener actually works
        this._onTouchStart = null;
        this._onClick = null;
      }

      connectedCallback() {
        this.video_section = this.querySelector(".wt-video");
        this.video_background_section = this.querySelector(".hero--video-background");

        const target =
          this.video_section ||
          this.video_background_section;

        if (!target) return;

        // Find the video element + clickable overlay
        const videoEl = target.querySelector("video");
        if (!videoEl) return;

        // Prevent heavy loading until user interacts (helps mobile)
        // (Doesn't block if video is already set to autoplay in Liquid; you should change that too.)
        videoEl.preload = "metadata";
        videoEl.muted = true;
        videoEl.playsInline = true;
        videoEl.setAttribute("playsinline", "");
        videoEl.setAttribute("webkit-playsinline", "");

        const clickSurface =
          target.classList.contains("hero--video-background")
            ? target.querySelector(".hero__overlay") || target
            : target;

        const play = () => this.playVideo(videoEl);

        // Save the same function references for removal later
        this._onTouchStart = play;
        this._onClick = play;

        clickSurface.addEventListener("touchstart", this._onTouchStart, { passive: true });
        clickSurface.addEventListener("click", this._onClick);
      }

      playVideo(videoEl) {
        // "playing" isn't real; use paused/ended/readyState
        if (!videoEl || (!videoEl.paused && !videoEl.ended)) return;

        // If it hasn't loaded yet, load then play
        if (videoEl.readyState === 0) {
          try { videoEl.load(); } catch (e) {}
        }

        const p = videoEl.play();
        if (p && typeof p.catch === "function") {
          p.catch(() => {
            // Autoplay/user gesture edge cases; ignore
          });
        }
      }

      disconnectedCallback() {
        const target =
          this.video_section ||
          this.video_background_section;

        if (!target) return;

        const clickSurface =
          target.classList.contains("hero--video-background")
            ? target.querySelector(".hero__overlay") || target
            : target;

        if (this._onTouchStart) {
          clickSurface.removeEventListener("touchstart", this._onTouchStart);
        }
        if (this._onClick) {
          clickSurface.removeEventListener("click", this._onClick);
        }

        this._onTouchStart = null;
        this._onClick = null;
        this.video_section = null;
        this.video_background_section = null;
      }
    }
  );
}
